import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, infoDescription, imgUrl, link, moreInfoLink }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        {/* <img src={imgUrl} alt =''/> */}
        <img src={imgUrl} alt={title} style={{ width: '100%', height: '250px', objectFit: 'contain' }} /> 
        <div className="proj-txtx">
          <h4>{title}</h4><br />
          <a href={link} target='blank' rel='noreferrer'><span>{description}</span></a> <br />
          <a href={moreInfoLink} target='blank' rel='noreferrer'><span>{infoDescription}</span></a>
        </div>
      </div>
    </Col>
  )
}